import { useState, useRef } from "react";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { getAtRiskStudents } from "../../lib/api";
import { printRef } from "../../lib/print";

export default function AtRiskTab({ startDate, endDate, setStartDate, setEndDate }) {
  const [atRiskStudents, setAtRiskStudents] = useState([]);
  const atRiskReportRef = useRef(null);

  const fetchAtRisk = async () => {
    try {
      const res = await getAtRiskStudents({ start_date: startDate, end_date: endDate });
      setAtRiskStudents(res.data);
    } catch { toast.error("Failed to load at-risk students"); }
  };

  return (
    <Card>
      <CardHeader><CardTitle>At-Risk Students</CardTitle><CardDescription>Students with less than 50% attendance rate</CardDescription></CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2"><Label>Start Date</Label><Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
          <div className="space-y-2"><Label>End Date</Label><Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
        </div>
        <Button onClick={fetchAtRisk} className="bg-[#A62E1D] hover:bg-[#A62E1D]/90" data-testid="generate-at-risk-btn">Generate At-Risk Report</Button>
        {atRiskStudents.length > 0 && (
          <>
            <div className="flex justify-end mt-4"><Button variant="outline" onClick={() => printRef(`At-Risk Students Report (${startDate} to ${endDate})`, atRiskReportRef)} data-testid="print-at-risk-btn"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect width="12" height="8" x="6" y="14"/></svg>Print Report</Button></div>
            <div ref={atRiskReportRef} className="mt-4">
              <h2 className="font-semibold mb-4">At-Risk Students (Below 50% Attendance)</h2>
              <table className="w-full text-sm"><thead><tr className="border-b"><th className="text-left py-2 px-3">Student</th><th className="text-left py-2 px-3">Attendance Rate</th><th className="text-left py-2 px-3">Days Present</th><th className="text-left py-2 px-3">Total Days</th></tr></thead>
                <tbody>{atRiskStudents.map((s, i) => (<tr key={i} className="border-b"><td className="py-2 px-3 font-medium">{s.name}</td><td className="py-2 px-3"><span className="px-2 py-1 rounded bg-red-100 text-red-800">{s.attendance_rate}%</span></td><td className="py-2 px-3">{s.days_present}</td><td className="py-2 px-3">{s.total_days}</td></tr>))}</tbody>
              </table>
            </div>
          </>
        )}
        {atRiskStudents.length === 0 && <p className="text-muted-foreground text-center py-4">No at-risk students found for the selected period</p>}
      </CardContent>
    </Card>
  );
}
